import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Input, Button, Loader } from 'wix-style-react'
import Text from 'components/common/Text'
import _ from 'lodash'

import MessageBoxFunctionalLayout from 'components/shared/MessageBoxFunctionalLayout'
import AppNameInput from 'components/shared/AppNameInput'
import { fetchInstagramImages } from 'controllers/integrations'
import { GRAY, HELVETICA, TEAL } from 'components/styles'


const Content = styled.div`
  width: 100%;
  height: 36em;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const HeaderText = styled.div`
  width: 100%;
  margin-top: 2em;
  text-align: center;
  ${HELVETICA};
  font-size: 36px;
  font-weight: 300;
  color: #72a4a3;
`
const Description = styled.div`
  width: 40%;
  margin-top: 3em;
  color: ${GRAY};
  text-align: center;
`
const AppNameInputContainer = styled.div`
  width: 60%;
  margin-top: 3em;
  text-align: center;
`
const InputsBlock = styled.div`
  margin-top: 3em;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 60%;
`
const InputContainer = styled.div`
  width: 70%;
`
const ErrorMessage = styled.div`
  width: 100%;
  margin-top: 1em;
  text-align: center;
  ${HELVETICA};
  font-size: 16px;
  font-weight: 300;
  color: red;
`
const DataContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 8
`
const Footer = styled.div`
  width: 95%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex: 1
`
const ButtonNext = styled.div`
  width: 157px;
  height: 52px;
  border-radius: 8px;
  background-color: ${TEAL};
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFF;
  ${HELVETICA};
  font-size: 23px;
  font-weight: 500;
  cursor: pointer;
`
const LoaderContainer = styled.div`
  margin-top: 3em;
`

const INIT = 'INIT'
const CONNECTING = 'CONNECTING'
const CONNECTED = 'CONNECTED'

class InstagramConnect extends Component {

  constructor (props) {
    super(props)
    this.state = {
      mode: INIT,
      error: false,
      instaName: props.instaName,
      appNameReady: false
    }
    this.apiCallback = this.instagramCallback
  }

  componentWillUnmount () {
    this.apiCallback = () => null
  }

  onInputChange = (e) => {
    e.preventDefault()
    this.setState({
      error: false,
      instaName: e.target.value
    })
  }

  instagramCallback = (res) => {
    console.log('instagramCallback', res)
    if (_.isNil(res)) {
      this.setState({
        mode: INIT,
        error: true
      })
    } else {
      this.setState({
        mode: CONNECTED,
        error: false
      })
      this.props.onChangeInstaName(this.state.instaName)
    }

  }

  connect = () => {
    const { dispatch } = this.props
    const { instaName } = this.state
    console.log('instagram name', instaName)
    this.setState({
      mode: CONNECTING
    })
    dispatch(fetchInstagramImages(instaName, null, this.apiCallback))
  }

  renderError = () => {
    if (this.state.error) {
      return (
        <ErrorMessage>Sorry, we can't connect to the instagram account.</ErrorMessage>
      )
    }
  }

  renderInitMode () {
    return (
      <Content>
        <HeaderText>Let’s get started!</HeaderText>
        <Description>
          To start making your Instagram posts shoppable, you’ll need to authorize us to pull posts from Instagram on your behalf.
        </Description>
        <InputsBlock>
          <InputContainer>
            <Input
              size='normal'
              value={_.isNil(this.state.instaName) ? '' : this.state.instaName}
              prefix={<Text>https://www.instagram.com/</Text>}
              onChange={this.onInputChange}
              maxLength={75}
            />
          </InputContainer>
          <Button disabled={_.isNil(this.state.instaName)} onClick={this.connect}>Connect</Button>
        </InputsBlock>
        {this.renderError()}
      </Content>
    )
  }

  renderConnectingMode () {
    return (
      <Content>
        <Description>
          We are connecting to your instagram account...
        </Description>
        <LoaderContainer>
          <Loader text='Loading...' />
        </LoaderContainer>
      </Content>
    )
  }

  onChangeAppName = (appName) => {
    this.setState({
      appNameReady: appName !== ''
    })
    this.props.onChangeAppName(appName)
  }

  renderConnectedMode () {
    return (
      <Content>
        <DataContainer>
          <HeaderText>Your Instagram account is connected</HeaderText>
          {/* <Description>
            Click next to connect your ecommerce platform.
          </Description> */}
          <AppNameInputContainer>
            <AppNameInput onChangeAppName={this.onChangeAppName} />
          </AppNameInputContainer>
        </DataContainer>
        <Footer>
          { this.state.appNameReady ? <ButtonNext onClick={this.props.toNextStep}>Next</ButtonNext> : null }
        </Footer>
      </Content>
    )
  }

  renderContent () {
    const { mode } = this.state
    switch (mode) {
      case INIT: return this.renderInitMode()
      case CONNECTING: return this.renderConnectingMode()
      case CONNECTED: return this.renderConnectedMode()
      default: return null
    }
  }

  render () {
    const { handleCancel } = this.props
    return (
      <MessageBoxFunctionalLayout
        theme='blue'
        title='Authorize your Instagram'
        onCancel={handleCancel}
        disableConfirmation
        hideFooter
        width='60em'
      >
        {this.renderContent()}
      </MessageBoxFunctionalLayout>
    )
  }
}

InstagramConnect.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  toNextStep: PropTypes.func.isRequired,
  onChangeInstaName: PropTypes.func.isRequired,
  instaName: PropTypes.string,
  onChangeAppName: PropTypes.func.isRequired,
}

export default connect()(InstagramConnect)



// WEBPACK FOOTER //
// ./src/components/dashboard/instagramWizard/InstagramConnect.js